'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FadeOut = _react2['default'].createClass({
    displayName: 'FadeOut',


    propTypes: {
        key: _react2['default'].PropTypes.string //NOTE: If another React component is leveraging this component, include a unique key for each generated message. See MultiSelect for more info.
    },

    getInitialState: function getInitialState() {
        return { isMounted: true };
    },

    componentDidMount: function componentDidMount(rootNode) {
        this.mountAndFadeOut();
    },

    componentWillUnmount: function componentWillUnmount() {
        _reactDom2['default'].unmountComponentAtNode(_reactDom2['default'].findDOMNode(this));
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (this.props.key !== nextProps.key) {
            this.mountAndFadeOut();
        }
    },

    mountAndFadeOut: function mountAndFadeOut() {
        _reactDom2['default'].render(_jsx('span', {}, void 0, this.props.children), this.refs.contents);
        this.fadeOut();
    },

    fadeOut: function fadeOut() {
        $(this.refs.contents).fadeOut(5000, function () {
            if (this.isMounted()) {
                _reactDom2['default'].unmountComponentAtNode(_reactDom2['default'].findDOMNode(this));
            }
        }.bind(this));
    },

    render: function render() {
        return _react2['default'].createElement('span', { style: { display: 'inline-block' }, ref: 'contents' });
    }
});
module.exports = FadeOut;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/fade-out.jsx
 ** module id = 809
 ** module chunks = 0
 **/